import React from "react";
import Layout from "./Layout.jsx";

const VerticalLayout = ({ ...props }) => {
	return <Layout {...props} orientation="vertical" />;
};

export default VerticalLayout;



// WEBPACK FOOTER //
// ./src/lib/components/Layout/VerticalLayout.jsx